<div class="user-chat w-100 overflow-hidden">
  <div class="chat-content d-lg-flex">
    <div class="w-100 overflow-hidden position-relative">
      <div class="position-relative">
        <div class="position-relative" id="users-chat" style="max-height: 260px;">
          <ngx-simplebar class="chat-conversation p-2" #scrollRef>
            @if (main_loading) {
              <div class="mt-5">
                <app-loading-spinner></app-loading-spinner>
              </div>
            }
            @if (!main_loading) {
              <ul class="list-unstyled chat-conversation-list" id="users-conversation">
                @for (data of chatMessagesData; track data; let i = $index) {
                  <li class="chat-list" [ngClass]="data.role === 'model' ? 'left' : 'right'">
                    <div class="conversation-list">
                      @if (data.role === 'model') {
                        <div class="chat-avatar">
                          <img src="{{ pchat }}" alt="">
                        </div>
                      }
                      <div class="user-chat-content">
                        <div class="ctext-wrap">
                          <div class="ctext-wrap-content">
                            @if (!data.loading) {
                              <div class="mb-0 ctext-content message-div" [ngClass]="chat_lang === 'he' ? 'rtl text-end' : ''" [innerHTML]="data.parts[0].text | formatAnswer"></div>
                            }
                            @if (data.loading) {
                              <app-loading-spinner [spinner]="3" [size]="1"></app-loading-spinner>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                }
              </ul>
            }
          </ngx-simplebar>
        </div>
        <div class="chat-input-section p-2">
          <form (ngSubmit)="messageSave()" [formGroup]="formData" id="chatinput-form" enctype="multipart/form-data">
            <div class="row g-0 align-items-center">
              <div class="col">
                @if (submitted && form['message'].errors) {
                  <div class="chat-input-feedback">
                    @if (form['message'].errors['required']) {
                      <span>Please Enter a Message</span>
                    }
                  </div>
                }
                <textarea class="form-control chat-input bg-light border-light"
                  id="chat-input"
                  style="resize: none; height: 37px;"
                  placeholder="{{ chat_lang === 'en' ? 'Type your message...' : 'הקלד את הודעתך...' }}"
                  autocomplete="off"
                  formControlName="message"
                  [ngClass]="{ 'is-invalid': submitted && form['message'].value === '' }"
                  [ngClass]="chat_lang === 'he' ? 'rtl' : ''">
                </textarea>
              </div>
              <div class="col-auto">
                <div class="chat-input-links ms-2">
                  <div class="links-list-item">
                    <button [disabled]="loading" type="submit" [ngbTooltip]="'Send Message'" placement="top" class="btn btn-primary chat-send waves-effect waves-light shadow">
                      <i class="ri-send-plane-2-fill align-bottom"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-auto">
                <div class="chat-input-links ms-2">
                  <div class="links-list-item">
                    <button type="button" (click)="changeChatLang()" [ngbTooltip]="'Change Language'" placement="top" class="btn btn-primary chat-send waves-effect waves-light shadow">
                      {{ chat_lang | uppercase }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-auto">
                <div class="chat-input-links ms-2">
                  <div class="links-list-item">
                    <button type="button" (click)="openResetChatModal()" [ngbTooltip]="'Reset Chat'" placement="top" class="btn btn-danger chat-send waves-effect waves-light shadow">
                      <i class="ri-delete-bin-line align-bottom"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #resetChatModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="modal.close('Close click')"></button>
    </div>
    <div class="modal-body">
      <div class="mt-2 text-center">
        <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>
        <div class="alert alert-danger">
          <p class="mb-0 text-uppercase">Once done, this action cannot be undone!!!</p>
        </div>
        <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
          <h4>Are you Sure You want to reset this chat?</h4>
          <p class="fw-semibold text-warning">This will reset all the history of this chat and can not be recover!</p>
        </div>
      </div>
      <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
        <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="modal.close('Close click')">Close</button>
        <button type="button" class="btn w-sm btn-danger btn-load" (click)="resetChat()">
          <span class="d-flex justify-content-center">
            @if (submitted && spinner) {
              <span class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </span>
            }
            <span [ngClass]="submitted && spinner ? 'ms-2' : ''">Yes, Reset It!</span>
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #successModal let-modal>
  <div class="modal-content">
    <div class="modal-body text-center p-5">
      <div class="text-end">
        <button class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="modal.close('Close click')"></button>
      </div>
      <div class="mt-2">
        @if (success) {
          <lord-icon src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover" style="width:150px;height:150px"></lord-icon>
        }
        @if (!success) {
          <lord-icon src="https://cdn.lordicon.com/tdrtiskw.json" trigger="loop" colors="primary:#f06548,secondary:#f7b84b" style="width:120px;height:120px"></lord-icon>
        }
        <h4 class="mb-3 mt-4">{{ successMessage }}</h4>
        @if (!success) {
          <p class="text-muted mx-4 mb-0">{{ message }}</p>
        }
      </div>
    </div>
  </div>
</ng-template>